import classNames from 'classnames';
import type { FormErrorSeverity, TranslatedValidationError } from 'models/formError';
import { FC } from 'react';
import styled from 'styled-components';

import { toColor } from '../../FormGroup/ErrorMessages/helper';

const MessageContainer = styled.div<{ $validationError: TranslatedValidationError }>`
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: ${({ $validationError }) => `var(--bs-${toColor($validationError)})`};
  align-items: center;

  .icon {
    border: 1px solid currentColor;
    border-radius: 50%;
    width: 0.7rem;
    height: 0.7rem;
    margin-right: 3px;
    line-height: 1;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
`;

export type UnderlyingsFeedbackMessageProps = {
  className?: string;
  validationError: TranslatedValidationError | undefined;
  e2e?: string;
};
type FormErrorIcon = 'close' | 'priority_high' | 'error_outline';
const formErrorSeverityToIconMapping: Record<FormErrorSeverity, FormErrorIcon> = {
  Error: 'close',
  Warning: 'priority_high',
  Failure: 'error_outline',
};
export const UnderlyingsValidationFeedbackMessage: FC<UnderlyingsFeedbackMessageProps> = ({
  className,
  validationError,
  e2e,
}) => {
  if (
    validationError === undefined ||
    validationError.isDisplayedInSummary ||
    !validationError.isDisplayedInUnderlyings
  ) {
    return null;
  }
  return (
    <MessageContainer
      className={classNames('field-feedback', className)}
      $validationError={validationError}
      data-e2e={e2e}
    >
      <em className="icon icon-xs">{formErrorSeverityToIconMapping[validationError.severity]}</em>
      {validationError.message}
    </MessageContainer>
  );
};

UnderlyingsValidationFeedbackMessage.displayName = 'UnderlyingsValidationFeedbackMessage';
